import { wrapMDX } from "./root-mdx";

export const wrapRootElement = wrapMDX;
